import {useEffect, useState} from "react";
import text from "./textsource.json"

function Policy(){

    const [click, setClick] = useState(false)
    const [hover, setHover] = useState(false)
    const [button, setButton] = useState(false)

    useEffect(()=>{
        if(window.location.pathname === '/policy'){
            setClick(true)
        }
        console.log(window.location.href)
    },[])

    return(
        <div>
        <div style={{width: 100, height: 100, color: 'rgb(40,40,255)', cursor: 'pointer', marginTop: 5, transform: hover ? 'scale(1.1)' : 'scale(1)'}}
             onMouseOver={()=>{
                 setHover(true)
             }}
             onMouseLeave={()=>{
                 setHover(false)
             }}
            onClick={()=>{
                setClick(true)
            }}
        >
            Integritetspolicy
        </div>
            {click ? (
                <div style={{display: 'flex', justifyContent: 'center', position: 'fixed', top:80, left: 0, width: '100vw', height: '100vh', backgroundColor:'rgba(0,0,0, 0.5)'}}
                onClick={()=>{
                    setClick(false)
                }}
                >

                    <div style={{maxWidth: 1000, padding: 20, display: 'flex', flexDirection: 'column', backgroundColor: 'rgb(40,40,40)', width: '80%', height: 'calc(90% - 150px)', marginTop: 25}}
                        onClick={(e)=>{
                           e.stopPropagation();
                        }}
                    >
                        <div style={{alignSelf: 'center'}}>
                            Integritetspolicy - Wetterstadens Bil AB
                        </div>
                        <div style={{alignSelf: 'center', marginBottom: 15}}>
                            Senast uppdaterad: 30/10 -26
                        </div>
                        <div style={{overflowY: 'scroll'}}>
                        {text.policy.map((mening)=>{
                            let number = mening.charAt(0)
                            if(isNaN(number)){
                                return(
                                    <div>
                                        {mening}
                                    </div>
                                )
                            }else{
                                return(
                                    <div style={{marginTop: 10}}>
                                        {mening}
                                    </div>
                                )
                            }


                        })}
                        </div>
                        <div style={{padding: 10, paddingLeft: 20, paddingRight: 20, backgroundColor: button ? 'rgb(80,80,80)' : 'rgb(60, 60, 60)', borderRadius: 10, alignSelf: 'center', marginTop: 10, width: 'auto', cursor: 'pointer', transform: button ? 'scale(1.1)' : 'scale(1)'}}
                            onClick={()=>{
                                setClick(false)
                            }}
                             onMouseEnter={()=>{
                                setButton(true)
                             }}
                             onMouseLeave={()=>{
                                 setButton(false)
                             }}
                        >
                            Stäng
                        </div>
                    </div>
                </div>
            ):null}
        </div>
    )
}

export default Policy;
